<!--赖传峰-->
<!--2021/12/15-->
<!--eslint-disable max-len-->
<template>
  <PathSlot v-bind="props">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.1336 6.14664C19.6506 5.66369 18.9952 5.39206 18.3125 5.39206H11.045L9.58277 3.19872C9.42354 2.95987 9.15548 2.81641 8.86842 2.81641H4.57566C3.8929 2.81641 3.23753 3.08803 2.75458 3.57098C2.27162 4.05393 2 4.70931 2 5.39206V17.4118C2 18.0945 2.27162 18.7499 2.75458 19.2329C3.23753 19.7158 3.8929 19.9874 4.57566 19.9874H13.3329V18.1122L4.75733 18.1121C4.53011 18.1121 4.31145 18.0215 4.15043 17.8605C3.98941 17.6995 3.89878 17.4808 3.89878 17.2536V5.60209C3.89878 5.37487 3.98941 5.15621 4.15043 4.99519C4.31145 4.83417 4.53011 4.74354 4.75733 4.74354H8.40892L9.87114 6.80844C10.0304 7.04729 10.2984 7.19075 10.5855 7.19075L18.1392 7.19503C18.3665 7.19503 18.5851 7.28565 18.7461 7.44668C18.9072 7.6077 18.9978 7.82636 18.9978 8.05358V9.5989H20.8881V7.96772C20.8881 7.28496 20.6165 6.62959 20.1336 6.14664Z"
      fill="currentColor"
    />
    <path
      d="M21 14.888L17.4611 11.5871C17.4016 11.5317 17.3092 11.5323 17.2504 11.5885L13.8051 14.888"
      stroke="currentColor"
      stroke-width="1.89"
      stroke-linecap="round"
    />
    <path
      d="M17.4019 12.4375L17.4019 19.2231"
      stroke="currentColor"
      stroke-width="1.89"
      stroke-linecap="round"
    />
  </PathSlot>
</template>

<script
  lang="ts"
  setup
>
import iconPropsType from './iconPropsType'
import PathSlot from './PathSlot.vue'

const props = defineProps(iconPropsType)
</script>
